/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssignmentRuleRequest
 */
export interface UpdateAssignmentRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRuleRequest
     */
    owner_user_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAssignmentRuleRequest
     */
    liaison_user_ids?: Array<string>;
}

/**
 * Check if a given object implements the UpdateAssignmentRuleRequest interface.
 */
export function instanceOfUpdateAssignmentRuleRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateAssignmentRuleRequestFromJSON(json: any): UpdateAssignmentRuleRequest {
    return UpdateAssignmentRuleRequestFromJSONTyped(json, false);
}

export function UpdateAssignmentRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssignmentRuleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'owner_user_id': !exists(json, 'owner_user_id') ? undefined : json['owner_user_id'],
        'liaison_user_ids': !exists(json, 'liaison_user_ids') ? undefined : json['liaison_user_ids'],
    };
}

export function UpdateAssignmentRuleRequestToJSON(value?: UpdateAssignmentRuleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'owner_user_id': value.owner_user_id,
        'liaison_user_ids': value.liaison_user_ids,
    };
}

